import { forceLogoutUsersByCommunity } from '@/js/utils/forceLogoutUsersByCommunity.js'
import { checkIsLoginValid } from '@/js/utils/index.js'
import router from '@/router.js'

/**
 * AB Test Plugin for Vuex
 * 使用 Vuex subscribe 方法監聽 state 變化
 * @param {Object} store - Vuex store 實例
 */
export default function forceLogoutUsersByCommunityPlugin (store) {
  // 初始化強制登出監聽
  // 情境：已登入狀態下，使用網址進入非登入畫面需確認是否需強制登出
  // 備註：等待 router 完全 ready 後才能順利判斷
  router.onReady(() => {
    const isLoginValid = checkIsLoginValid()
    const currentRouteName = router.currentRoute?.name
    if (isLoginValid && currentRouteName !== 'LoginMain') {
      forceLogoutUsersByCommunity()
    }
  })

  // 監聽 state 變化
  store.subscribe((mutation, _) => {
    if (
      (mutation.type === 'setLocalStorage' && mutation.payload.key === 'loginUserInfo')
    ) {
      // 社區切換時要重新獲取強制登出相關資訊
      // 情境一：選完社區後、進入首頁前要確認是否需強制登出
      // 情境二：雙開分頁，後一分頁登出再登入另一社區，原分頁也要更新監聽的社區
      // 情境三：雙開分頁，使用 EIP 登入另一社區，原分頁也要更新監聽的社區
      forceLogoutUsersByCommunity()
    }
  })
}
